import { enums } from '@optimizely/react-sdk';
import { logLevels } from './constants.js';

var appName = '';
var getLogLevelStr = function getLogLevelStr(logLevel) {
  var LOG_LEVEL = enums.LOG_LEVEL;
  var strLogLevel = '';
  switch (logLevel) {
    case LOG_LEVEL.INFO:
      strLogLevel = logLevels.INFO;
      break;
    case LOG_LEVEL.DEBUG:
      strLogLevel = logLevels.DEBUG;
      break;
    case LOG_LEVEL.WARNING:
      strLogLevel = logLevels.WARN;
      break;
    case LOG_LEVEL.ERROR:
      strLogLevel = logLevels.ERROR;
      break;
  }
  return strLogLevel;
};
var setAppName = function setAppName(name) {
  appName = name;
};
var getAppName = function getAppName() {
  return appName;
};
var getLogMessage = function getLogMessage(logLevel, message) {
  return "".concat(getAppName(), " : ").concat(getLogLevelStr(logLevel), " : ").concat(message);
};

export { getAppName, getLogLevelStr, getLogMessage, setAppName };
